import React from 'react';

interface ViewProps {
  width?: number;
  height?: number;
}

export const RightTripleView = ({ width = 66, height = 50 }: ViewProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 66 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="39" height="22" rx="1.5" stroke="#333745" strokeDasharray="3 3" />
    <rect
      x="44.5"
      y="0.5"
      width="21"
      height="22"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect x="46.5" y="2.49997" width="17" height="18" rx="2" fill="#F3F4F6" />
    <path
      d="M51.3741 12.5044C51.4405 12.3979 51.5328 12.3101 51.6424 12.2493C51.7519 12.1884 51.8751 12.1565 52.0004 12.1565C52.1256 12.1565 52.2488 12.1884 52.3583 12.2493C52.4679 12.3101 52.5602 12.3979 52.6266 12.5044L55 16.312H49L51.3734 12.5044H51.3741Z"
      fill="#DDE0E4"
    />
    <path
      d="M56.1395 9.21566C56.2008 9.09266 56.2951 8.98921 56.4117 8.91691C56.5284 8.8446 56.6629 8.8063 56.8 8.8063C56.9372 8.8063 57.0716 8.8446 57.1883 8.91691C57.305 8.98921 57.3993 9.09266 57.4606 9.21566L61 16.3126H52.6L54.7002 12.1015L56.1402 9.21566H56.1395Z"
      fill="#DDE0E4"
    />
    <path
      d="M52.0004 10.2974C52.9947 10.2974 53.8008 9.4893 53.8008 8.49245C53.8008 7.49561 52.9947 6.6875 52.0004 6.6875C51.0061 6.6875 50.2001 7.49561 50.2001 8.49245C50.2001 9.4893 51.0061 10.2974 52.0004 10.2974Z"
      fill="#DDE0E4"
    />
    <rect
      x="0.5"
      y="27.5"
      width="65"
      height="22"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
  </svg>
);
